import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import Logo from "../../assets/svg/AI.Logo.svg";
import { useTranslation } from "react-i18next";

const NavDrawer = ({ isOpen, toggleMenu, setIsModalOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();

  const openAuthModal = () => {
    toggleMenu();
    setIsModalOpen(true);
  };
  const handleScrollCalculator = () => {
    navigate("/");
    const worksSection = document.getElementById("calculator");
    if (worksSection) {
      worksSection.scrollIntoView({ behavior: "smooth" });
    }
  };
  const handleLanguageChange = (e) => {
    const newLang = e.target.value;
    if (newLang === i18n.language) return;
    i18n.changeLanguage(newLang);
    const pathParts = location.pathname.split("/").filter(Boolean);
    if (newLang === "en") {
      if (pathParts[0] !== "en") {
        navigate("/en" + location.pathname, { replace: true });
      }
    } else {
      if (pathParts[0] === "en") {
        // Remove 'en' from path
        const newPath = "/" + pathParts.slice(1).join("/");
        navigate(newPath === "/" ? "/" : newPath, { replace: true });
      }
    }
  };
  return (
    <div>
      <Drawer
        open={isOpen}
        onClose={toggleMenu}
        direction="top"
        style={{ height: "300px" }}
      >
        <div className="flex items-center gap-2 px-4 pt-4 pb-2">
          <Link
            to={i18n.language === "en" ? "/en" : "/"}
            className="flex items-center min-w-0"
            onClick={toggleMenu}
          >
            <img
              src={Logo}
              alt="OfficeFinder Logo"
              className="h-10 sm:h-12 md:h-16 w-auto object-contain max-w-[130px] sm:max-w-[140px] md:max-w-[160px] transition-all"
            />
          </Link>
        </div>
        <ul
          className={`flex flex-col items-center gap-3 xl:gap-7 md:items-center lg:justify-end`}
        >
          <li className={`mr-0 my-2 ${"lg:my-0 mt-6 lg:mt-0"}`}>
            <Link
              to={i18n.language === "en" ? "/en/how-it-works" : "/how-it-works"}
              className="text-primary-text font-medium hover:text-cyan-900 cursor-pointer"
              onClick={toggleMenu}
            >
              {t("how_it_works")}
            </Link>
          </li>
          <li>
            <Link
              className="text-primary-text font-medium hover:text-cyan-900"
              to={i18n.language === "en" ? "/en/contact-us" : "/contact-us"}
              onClick={toggleMenu}
            >
              {t("contact")}
            </Link>
          </li>
          <li>
            <p
              onClick={() => {
                navigate(i18n.language === "en" ? "/en" : "/");
                setTimeout(() => {
                  const worksSection = document.getElementById("calculator");
                  if (worksSection) {
                    worksSection.scrollIntoView({ behavior: "smooth" });
                  }
                }, 100);
                toggleMenu();
              }}
              className="text-primary-text font-medium hover:text-cyan-900 cursor-pointer"
            >
              {t("find_office")}
            </p>
          </li>
        </ul>
        {/* Language Switcher at the bottom */}
        <div className="w-full flex justify-center mt-8 mb-4">
          <div className="relative w-full max-w-xs">
            <select
              value={i18n.language}
              onChange={handleLanguageChange}
              className="
                border
                rounded-[58px]
                py-2
                px-6
                pr-10
                min-w-[140px]
                cursor-pointer
                text-primary-text
                font-medium
                appearance-none
                bg-white
                text-center
                focus:outline-none
                focus:ring-2
                focus:ring-red-500
                focus:border-red-500
                transition
                duration-150
                ease-in-out
                shadow-sm
                hover:border-red-400
                hover:shadow-md
                w-full
              "
              style={{ boxShadow: "0 2px 8px 0 rgba(0,0,0,0.06)" }}
            >
              <option
                value="en"
                className="bg-white text-cyan-900 hover:bg-red-100"
              >
                English
              </option>
              <option
                value="ro"
                className="bg-white text-cyan-900 hover:bg-red-100"
              >
                Romanian
              </option>
            </select>
            {/* Custom arrow icon */}
            <div className="pointer-events-none absolute inset-y-0 right-4 flex items-center">
              <svg
                className="w-4 h-4 text-gray-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default NavDrawer;
